import axios, { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { Culture } from '@/types/culture'
import { Treatment } from '@/types/treatment'

type ResolutionType = 'proceed' | 'cancel' | 'upload_file'

interface Files {
  perimeter?: {
    area: number
    centroid: [number, number]
    filename: string
  }
  mosaic?: {
    filename: string
    gsd: number
    coord_x: number
    coord_y: number
    px_res: number
  }
}

interface Issue {
  title: string
  description: string
  name: string
}

interface User {
  id: number
  name: string
}

interface Report {
  id: string
  diagnosis_id: string
  created_by: User
  created_at: string
  issues: Issue[]
  comment: string
  resolution: ResolutionType
  resolved_at: string | null
  resolved_by: User
  resolution_files: Record<string, unknown>
}

export interface CreateReportResolutionPayload {
  resolution: ResolutionType
  resolved_by: number
  files_in_resolution?: Files
}

interface ReportResolutionResponse {
  message: string
  report: Report
  need_confirmation: boolean
  urls: {
    mosaic: string
    perimeter: string
  }
}

export async function createReportResolution(
  treatment: Treatment,
  culture: Culture,
  diagnosisId: string,
  reportId: string,
  payload: CreateReportResolutionPayload,
  config?: AxiosRequestConfig,
): Promise<ReportResolutionResponse> {
  const { data } = await companiesApi.post<ReportResolutionResponse>(
    apiRoutes.reportResolution(treatment, culture, diagnosisId, reportId),
    payload,
    config,
  )

  if (data.urls?.mosaic) {
    const { headers } = await axios.post(data.urls.mosaic, null, {
      headers: {
        'x-goog-resumable': 'start',
        'Content-Type': 'application/octet-stream',
        'Content-Disposition': `attachment;filename="${payload.files_in_resolution?.mosaic?.filename}"`,
      },
    })

    data.urls.mosaic = headers.location
  }

  return data
}
